import axios from "axios";
import React, { useState } from "react";
import { toast } from "react-hot-toast";
import { useNavigate } from "react-router-dom";

const { REACT_APP_BACKEND_URL } = process.env;

const CreateUser = () => {
  const [formData, setFormData] = useState({
    firstname: "",
    lastname: "",
    email: "",
    password: "",
    confirmPassword: "",
    showPassword: false,
  });

  const {
    firstname,
    lastname,
    email,
    password,
    confirmPassword,
    showPassword,
  } = formData;
  const navigate = useNavigate();

  const onChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const togglePasswordVisibility = () => {
    setFormData({ ...formData, showPassword: !showPassword });
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      toast.error("Passwords do not match!! 🚫🚫");
      return;
    }
    try {
      const res = await axios.post(
        `${REACT_APP_BACKEND_URL}/api/auth/register`,
        { firstname, lastname, email, password }
      );
      toast.success(res.data.msg);
      navigate("/users");
    } catch (err) {
      console.error(err.response.data);
      toast.error(err.response.data.msg || "Registration failed 🚫🚫");
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="bg-white shadow-md rounded-lg px-8 py-6 w-full max-w-md">
        <h1 className="text-2xl font-bold mb-6 text-center">Add User</h1>
        <form onSubmit={onSubmit}>
          <div className="mb-4">
            <input
              type="text"
              placeholder="First Name"
              name="firstname"
              value={firstname}
              onChange={onChange}
              required
              className="w-full px-3 py-3 border border-gray-300 rounded-md focus:outline-none focus:border-black transition duration-300"
            />
          </div>
          <div className="mb-4">
            <input
              type="text"
              placeholder="Last Name"
              name="lastname"
              value={lastname}
              onChange={onChange}
              required
              className="w-full px-3 py-3 border border-gray-300 rounded-md focus:outline-none focus:border-black transition duration-300"
            />
          </div>
          <div className="mb-4">
            <input
              type="email"
              placeholder="Email"
              name="email"
              value={email}
              onChange={onChange}
              required
              className="w-full px-3 py-3 border border-gray-300 rounded-md focus:outline-none focus:border-black transition duration-300"
            />
          </div>
          <div className="flex flex-col md:flex-row gap-4 mb-4">
            <input
              type={showPassword ? "text" : "password"}
              placeholder="Password"
              name="password"
              value={password}
              minLength="8"
              onChange={onChange}
              className="w-full px-3 py-3 border border-gray-300 rounded-md focus:outline-none focus:border-black transition duration-300"
            />
            <input
              type={showPassword ? "text" : "password"}
              placeholder="Confirm Password"
              name="confirmPassword"
              value={confirmPassword}
              onChange={onChange}
              className="w-full px-3 py-3 border border-gray-300 rounded-md focus:outline-none focus:border-black transition duration-300"
            />
          </div>
          <div className="mb-4 flex items-center">
            <input
              type="checkbox"
              id="showPassword"
              onChange={togglePasswordVisibility}
              className="mr-2"
            />
            <label htmlFor="showPassword" className="text-sm">
              Show Password
            </label>
          </div>
          <button
            type="submit"
            className="w-full bg-black text-white py-3 px-4 rounded-md hover:bg-gray-900 transition duration-300"
          >
            Add
          </button>
        </form>
      </div>
    </div>
  );
};

export default CreateUser;
